var widgets = require('../lib/widgets');

widgets.create('MobileNav', require('./MobileNav'));
widgets.create('Field', require('./Field'));
widgets.create('Address', require('./Address'));
widgets.create('DateField', require('./DateField'));
widgets.create('AddressForm', require('./AddressForm'));
widgets.create('BookingAddress', require('./BookingAddress'));
widgets.create('CustomSelect', require('./CustomSelect'));
widgets.create('RangeSlider', require('./RangeSlider'));
widgets.create('UploadField', require('./UploadField'));
widgets.create('Upload', require('./Upload'));
widgets.create('Form', require('./Form'));
widgets.create('Equalise', require('./Equalise'));
widgets.create('BookingTable', require('./BookingTable'));
widgets.create('SubNavItem', require('./SubNavItem'));
widgets.create('MobileSubNavItem', require('./MobileSubNavItem'));
widgets.create('ItemSlider', require('./ItemSlider'));
widgets.create('HeroSlider', require('./HeroSlider'));
widgets.create('CommentSlider', require('./CommentSlider'));
widgets.create('LoadMore', require('./LoadMore'));
widgets.create('StyleTrack', require('./StyleTrack'));
widgets.create('ShowHide', require('./ShowHide'));
widgets.create('ScrollAnchor', require('./ScrollAnchor'));
widgets.create('MultiOverlayItem', require('./MultiOverlayItem'));
widgets.create('Tabs', require('./Tabs'));



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/index.js
// module id = 9
// module chunks = 0